import React from "react";
import { getGatsbyImageData } from "gatsby-source-sanity";
import { GatsbyImage } from "gatsby-plugin-image";
import sanityConfig from "../../config/sanity";

const SanityImage = ({
  input,
  maxWidth = 1500,
  maxHeight = 1200,
  objectFit = "contain"
}) => {
  const { image, caption } = input;

  const imageData = getGatsbyImageData(
    image.asset,
    { maxWidth: maxWidth, maxHeight: maxHeight },
    sanityConfig.sanity
  );
  // console.log(input);
  const backgroundColorDominant = image.asset.metadata
    ? image.asset.metadata.palette.dominant.background
    : "transparent";

  return (
    <figure>
      <div
        className='bg-gray-100 h-full'
        style={{
          background: backgroundColorDominant
        }}>
        <GatsbyImage
          image={imageData}
          alt={caption ? caption : ""}
          objectFit={objectFit}
        />
      </div>
      {caption && (
        <figcaption className='text-sm px-md py-sm'>{caption}</figcaption>
      )}
    </figure>
  );
};

export default SanityImage;
